import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import { Accordion, Card, Button,  } from 'react-bootstrap';
import Slider from "react-slick";
import { slickDot } from "../../utils/script";
import SectionTitle from "../sectionTitle/SectionTitle";

import {Link} from "react-router-dom";
import { FiArrowRight, FiCheck } from "react-icons/fi";
import { FcGlobe } from "react-icons/fc";


const TestimonialData = [
    {
        form: "Poland",
        description: "New UFTAA Global Team from Eleven Countries, elected for 2025-2026. 1966 to 2025 has been a journey that UFTAA proudly reflects. 59 years of successful industry leadership and representation is what UFTAA is all about. UFTAA (United Federation of Travel Agents Associations) is an international confederation representing the travel agency and tourism industry, founded in 1966 and headquartered in Monaco, aims to unify travel agencies, promote sustainable tourism, and advocate for the industry's interests globally. It is a huge networking opportunity for the industry stake-holders across the world.",
        name: "UFTAA ANNOUNCES 2026 as DIAMOND JUBILEE YEAR",
        subtitle: "App Developer",
        image: "testimonial-dark-01"
    },
    {
        form: "Germany",
        description: "",
        name: "UFTAA TEAM JOINS IATA's 54th PAPGJC MEETING @ Madrid (MARCH 2025)",
        subtitle: "App Developer",
        image: "testimonial-dark-02"
    },
    {
        form: "USA",
        description: "",
        name: "UFTAA BOARD MEETING at New Delhi - February 2025",
        subtitle: "App Developer",
        image: "testimonial-dark-03"
    },
    ,
    {
        form: "USA",
        description: "",
        name: "UFTAA successfully partners with SATTE (B2B Program) - February 2025",
        subtitle: "App Developer",
        image: "testimonial-dark-03"
    },
]

const teamData = [
    {
        image: 'sunil',
        name: 'Sunil Kumar Rumalla',
        designation: 'President, UFTAA',
    },
    {
        image: 'Yossi',
        name: 'Yossi Fatael',
        designation: 'Vice President, UFTAA',
    },
    {
        image: 'WILLIAM',
        name: 'William D’souza',
        designation: 'Vice President (Finance)',
    },
    {
        image: 'Gurcun',
        name: 'Cetin Gurcun',
        designation: 'Vice President (Tourism)',
    },
    {
        image: 'Varsha',
        name: 'Varsha Ramchurn',
        designation: 'Board Member,UFTAA',
    },
    {
        image: 'Olivier',
        name: 'Joe Borg Olivier',
        designation: 'Board Member,UFTAA',
    },
    {
        image: 'DUMINDA',
        name: 'Duminda  Kuruwitaarachch',
        designation: 'Board Member,UFTAA',
    },
    {
        image: 'JOSEPH',
        name: 'Dr Joseph Kithitu',
        designation: 'Board Member,UFTAA',
    },
    {
        image: 'MARIEGEL',
        name: 'Mariegel Manotok',
        designation: 'Board Member,UFTAA',
    },

]

const AboutTwo = () => {
    var settings = {
        dots: false,
        infinite: true,
        speed: 50,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000
      };

      var settings2 = {
        dots: false,
        infinite: true,
        speed: 2000,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: true,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                initialSlide: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]

      };

    return (
        <div className="rwt-about-area about-style-2 rn-section-gap">
            <div className="container">
                {/* <div className="row row--30 align-items-center"> */}
                    {/* <div className="col-lg-5">
                        <div className="thumbnail">
                            <img className="w-100" src="./images/about/worldshore-about.jpeg" alt="About Images" />
                        </div>
                    </div> */}

                    <div className="row">
                        <div className="col-lg-4 col-md-5 col-sm-4 col-12 mt_md--15 mt_sm--30">
                                <div className="section-title" >
                                <Accordion className={`rn-accordion-style`}>
                                <Card style={{borderRadius:"50"}} className="cardBackground2">
                                    <Card.Header className="cardBackground2" style={{"borderRadius":"10px"}}>
                                    <Accordion.Toggle as={Button} variant="link" eventKey="0" style={{"borderRadius":"50px"}}>
                                        <h2 className="title mt--10"><span className="theme-gradient" style={{fontSize:"20px"}}>Objectives of UFTAA</span></h2>
                                    </Accordion.Toggle>
                                    </Card.Header>
                                    <Accordion.Collapse eventKey="0">
                                        <Card.Body className="cardBackground2"><p style={{color:"#2c56a5", fontSize: "15px"}}>The Universal Federation of Travel Agent Association plays an important role in the promotion and development of travel and tourism and its products. Some important aims and objective of Universal Federation of Travel Agent Associations are following as:</p>
                                                    <div className="content" style={{marginTop:"-15px"}}>
                                                        <h4 className="title w-600" style={{color:"#212170", fontSize:"15px"}} dangerouslySetInnerHTML={{__html: "To ensure public recognition of members."}}></h4>
                                                        <h4 className="title w-600" style={{color:"#212170", fontSize:"15px"}} dangerouslySetInnerHTML={{__html: "To protect interest from legislation and other forms of the legal point of view."}}></h4>
                                                        <h4 className="title w-600" style={{color:"#212170", fontSize:"15px"}} dangerouslySetInnerHTML={{__html: "To act as a negotiating body."}}></h4>
                                                        <h4 className="title w-600" style={{color:"#212170", fontSize:"15px"}} dangerouslySetInnerHTML={{__html: "To improve the professional status and business standing."}}></h4>
                                                        <h4 className="title w-600" style={{color:"#212170", fontSize:"15px"}} dangerouslySetInnerHTML={{__html: "To improve up to date information."}}></h4>
                                                    </div>
                                         </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                                </Accordion>
                                </div>
                                       
                        </div>
                       
                        <div className="col-lg-4 col-md-5 col-sm-4 col-12 mt_md--15 mt_sm--30">
                                <div className="section-title">
                                <Accordion className={`rn-accordion-style`}>
                                <Card>
                                    <Card.Header className="cardBackground2" style={{"borderRadius":"10px"}}>
                                    <Accordion.Toggle as={Button} variant="link" eventKey="0">
                                        <h2 className="title mt--10"><span className="theme-gradient" style={{fontSize:"20px"}}>Why Join UFTAA?</span></h2>
                                    </Accordion.Toggle>
                                    </Card.Header>
                                    <Accordion.Collapse eventKey="0">
                                        <Card.Body className="cardBackground2">
                                        <ScrollAnimation 
                                        animateIn="fadeInUp"
                                        animateOut="fadeInOut"
                                        animateOnce={true}>
                                        <p style={{color:"#2c56a5", fontSize: "15px"}}>A global body with a highly established and glorious past
                                        Vast Experience in travel & tourism industry </p>
                                        <p style={{color:"#2c56a5", fontSize: "15px"}}>Connectivity with key Global organizations - well known for its b2b opportunities to the industry buyers-sellers - leaders who have travel & tourism association as its members - affiliate members (individual agencies) are offered the excellent opportunity for a "global connect" - institutions can thrive with affiliation training and careers for students has been an hallmark of UFTAA - UFTAA offers a strong future-connect that industry presence and leadership.</p>

                                            </ScrollAnimation>
                                         </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                                </Accordion>
                                </div>
                                       
                        </div>

                        <div className="col-lg-4 col-md-5 col-sm-4 col-12 mt_md--15 mt_sm--30">
                                <div className="section-title">
                                <Accordion className={`rn-accordion-style`}>
                                <Card>
                                    <Card.Header className="cardBackground2" style={{"borderRadius":"10px"}}>
                                    <Accordion.Toggle as={Button} variant="link" eventKey="1">
                                        <h2 className="title mt--10"><span className="theme-gradient" style={{fontSize:"20px"}}>EVENTS – ACTIVITIES – INITIATIVES</span></h2>
                                    </Accordion.Toggle>
                                    </Card.Header>
                                    <Accordion.Collapse eventKey="1">
                                        <Card.Body className="cardBackground2">
                                        <ScrollAnimation 
                                        animateIn="fadeInUp"
                                        animateOut="fadeInOut"
                                        animateOnce={true}>
                                        <p style={{color:"#2c56a5", fontSize: "15px"}}>UFTAA is well known by the various events and activities it is involved and associated with. Annually, UFTAA organizes Annual General Assembly; UFTAA FORUM on IATA Matters; UFTAA’s TOURISM FORUM and more. UFTAA extends to its Associations, the opportunity of UFTAA leaders making presentations on Tourism; Aviation and related Industry matters. The vast experience and expertise UFTAA possesses is of great value to the content of such events organized by Associations, particularly at their Conventions. UFTAA has launched several initiatives to help industry stake holders upgrade them into better levels</p>


                                            </ScrollAnimation>
                                         </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                                </Accordion>
                                </div>
                                       
                        </div>

                  
                    </div>
                    <div className="row row--30 align-items-center mt_md--15 mt--30">

                    <div className="section-title">

                    <ScrollAnimation 
                    animateIn="fadeInUp"
                    animateOut="fadeInOut"
                    animateOnce={true}>
                    <div className={`service service__style--1 bg-color-white radius align-items-center cardBackground2`} style={{fontSize:"30px", textAlign:"center"}}>
                    <p style={{color:"#2c56a5", fontSize: "15px"}}>UFTAA has launched several initiatives – Education; Offline to Online initiatives for travel & tourism companies; Partnerships and more to help industry stake holders upgrade them into better levels. Towards this, UFTAA is actively involved in the design of UFTAA CONNECT (an online solution for every agency without any major investment); UFTAA-“.TRAVEL Domain Extension” partnership; MOU with SKAL International, a Global MOU to support Industry through campaigns and joint activities; partnership with WATA (World Association of Travel Agents), A global DMC network with IRU and more.</p>

                    <ScrollAnimation 
                    animateIn="fadeInUp"
                    animateOut="fadeInOut"
                    animateOnce={true}>
                        <h3 className="title mt--10"><span style={{fontSize:"30px", textAlign:"center", color:"#2c56a5"}}>Be a part of a growing world of travel & tourism professionals</span></h3>
                        <h3 className="title mt--10"><span  style={{fontSize:"30px", textAlign:"center", color:"#2c56a5"}}>Get your products - services a wider global coverage</span></h3>
                    </ScrollAnimation>

                    </div>
                </ScrollAnimation>
                    </div>   
                    </div>

                    <div className="row row--30 mt--30">
                        
                        <div className="col-lg-4 mt_md--15 mt_sm--30">
                        <div className="content">
                            <div className="section-title">
                            <div className="section-title">
                                <Accordion className={`rn-accordion-style`}>
                                <Card style={{borderRadius:"50"}} className="cardBackground2">
                                    <Card.Header className="cardBackground2" style={{"borderRadius":"10px"}}>
                                    <Accordion.Toggle as={Button} variant="link" eventKey="0">
                                        <h2 className="title mt--10"><span className="theme-gradient" style={{fontSize:"20px"}}>TOURISM</span></h2>
                                    </Accordion.Toggle>
                                    </Card.Header>
                                    <Accordion.Collapse eventKey="0">
                                        <Card.Body className="cardBackground2">
                                        <p style={{color:"#2c56a5", fontSize: "15px"}}>UFTAA’s role in Global Tourism and promotion of Tourism is extensive. UFTAA has been actively engaged in promotion of Tourism and towards establishing a global Tourism Network, has established the Global Tourism Office in Istanbul, Turkey. Thanks to our member – TURSAB, Turkey, this office is housed in an excellent location and is aimed to connect the tourism specialists of the world.</p>
                                            <p style={{color:"#2c56a5", fontSize: "15px"}}>UFTAA is actively connected with several large Tourism and Exhibition Organizing organizations and has been actively connected, year on year. UFTAA’s delegates, from all over the world, attend such Exhibitions or MICE activity to help our tourism specialist members to join such events.</p>
                                            <p style={{color:"#2c56a5", fontSize: "15px"}}>To name a few, UFTAA partnerships have extended with ITB ASIA(Singapore); South Asia’s Leading Travel Show – SATTE (India); International Mediterranean Tourism Market – IMTM (Israel); Luxury Tourism Workshop (Venice); World Tourism Exchange, China; India Tourism Mart (ITM) India; and more. </p>
                                            <p style={{color:"#2c56a5", fontSize: "15px"}}> UFTAA'S Goal include : Defending the interests of travel and tourism agencies and tour operators.
                                            Strengthening the image of its members.
                                            Enhancing the world's travel and tourism industry.
                                            Promoting sustainable tourism.</p>                                                    
                                                    
                                         </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                                </Accordion>
                                </div>
                        
                                
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 mt_md--15 mt_sm--30">
                        <div className="content">
                            <div className="section-title">
                            <div className="section-title">
                                <Accordion className={`rn-accordion-style`}>
                                <Card style={{borderRadius:"50"}} className="cardBackground2">
                                    <Card.Header className="cardBackground2" style={{"borderRadius":"10px"}}>
                                    <Accordion.Toggle as={Button} variant="link" eventKey="0">
                                        <h2 className="title mt--10"><span className="theme-gradient" style={{fontSize:"20px"}}>UFTAA & IATA</span></h2>
                                    </Accordion.Toggle>
                                    </Card.Header>
                                    <Accordion.Collapse eventKey="0">
                                        <Card.Body className="cardBackground2">
                                        <p style={{color:"#2c56a5", fontSize: "15px"}}>As a globally recognized body, UFTAA is the longest established negotiating partner with the leading travel and tourism organisations in the world. Of a special importance is the close co-operation with IATA, representing the interest of travel agents. UFTAA had partnered in IATA-UFTAA Training Programme. UFTAA represents the industry in the IATA’s PAPGJC – Passenger Agency Program Global Joint Council.</p>
                                    <p style={{color:"#2c56a5", fontSize: "15px"}}>PAPGJC – Passenger Agency Programme Global Joint Council has been established to manage the agent / airline relationship, provide a consultation forum for Conference decisions and jointly promote the IATA Passenger Agency Programme to airlines and agents. UFTAA is on the Global Joint Council of IATA and regularly debates with the Airlines and IATA on resolutions that are proposed, from time to time. Prior to the resolution on proposed resolutions, the proposals are debated at the PAPGJC meetings where UFTAA delegate debate actively. UFTAA has been most regular in attending all such meetings. The last such meeting, with presence of PAPGJC delegates was in Geneva during February, 2020.
                                    Post COVID-19, we are now involved with PAPGJC meetings on a regular basis. Never before so many PAPGJC meetings are held over conference calls with IATA; Airline Representatives and Agency Representatives in active deliberation.</p>                                                  
                                                    
                                         </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                                </Accordion>
                                </div>
                        
                                
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 mt_md--15 mt_sm--30">
                        <div className="content">
                            <div className="section-title">
                            <div className="section-title">
                                <Accordion className={`rn-accordion-style`}>
                                <Card style={{borderRadius:"50"}} className="cardBackground2">
                                    <Card.Header className="cardBackground2" style={{"borderRadius":"10px"}}>
                                    <Accordion.Toggle as={Button} variant="link" eventKey="0">
                                        <h2 className="title mt--10"><span className="theme-gradient" style={{fontSize:"20px"}}>Contribution and Role of UFTAA</span></h2>
                                    </Accordion.Toggle>
                                    </Card.Header>
                                    <Accordion.Collapse eventKey="0">
                                        <Card.Body className="cardBackground2">
                                        <p style={{color:"#2c56a5", fontSize: "15px"}}>Universal Federation of  Travel Agent Associations is an organization which is dedicated to travel and tourism. It is a global travel and tourism organization at the world level.  UFTAA promotes and develops tourism at the national level as well as the international level. Some important role and contribution of UFTAA are following as:</p>

                                    <div className="content">
                                        <h4 className="title w-600" style={{color:"#212170", fontSize:"15px"}} dangerouslySetInnerHTML={{__html: "Promotion travel sector"}}></h4>
                                        <h4 className="title w-600" style={{color:"#212170", fontSize:"15px"}} dangerouslySetInnerHTML={{__html: "Promote destination"}}></h4>
                                        <h4 className="title w-600" style={{color:"#212170", fontSize:"15px"}} dangerouslySetInnerHTML={{__html: "Negotiation"}}></h4>
                                        <h4 className="title w-600" style={{color:"#212170", fontSize:"15px"}} dangerouslySetInnerHTML={{__html: "Co-operate with international bodies"}}></h4>
                                        <h4 className="title w-600" style={{color:"#212170", fontSize:"15px"}} dangerouslySetInnerHTML={{__html: "Promotion status/development process"}}></h4>
                                        <h4 className="title w-600" style={{color:"#212170", fontSize:"15px"}} dangerouslySetInnerHTML={{__html: "Help to settle a dispute"}}></h4>
                                        <h4 className="title w-600" style={{color:"#212170", fontSize:"15px"}} dangerouslySetInnerHTML={{__html: "Develop payment systems"}}></h4>
                                        <h4 className="title w-600" style={{color:"#212170", fontSize:"15px"}} dangerouslySetInnerHTML={{__html: "Research studies"}}></h4>
                                        <h4 className="title w-600" style={{color:"#212170", fontSize:"15px"}} dangerouslySetInnerHTML={{__html: "Develop ethics"}}></h4>
                                        <h4 className="title w-600" style={{color:"#212170", fontSize:"15px"}} dangerouslySetInnerHTML={{__html: "Helps to standardize relations"}}></h4>
                                        <h4 className="title w-600" style={{color:"#212170", fontSize:"15px"}} dangerouslySetInnerHTML={{__html: "Develops vocational training courses"}}></h4>
                                        <h4 className="title w-600" style={{color:"#212170", fontSize:"15px"}} dangerouslySetInnerHTML={{__html: "Organize seminars, conferences for the development of technology"}}></h4>
                                        <h4 className="title w-600" style={{color:"#212170", fontSize:"15px"}} dangerouslySetInnerHTML={{__html: "Helps the members in transferring foreign currency payments to their suppliers"}}></h4>
                                        <h4 className="title w-600" style={{color:"#212170", fontSize:"15px"}} dangerouslySetInnerHTML={{__html: "UFTAA also negotiates on the behalf of travel agencies with the international organization like IATA, IHA, IUR, and IRU"}}></h4>

                                    </div>
                                         </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                                </Accordion>
                                </div>
                        
                                
                            </div>
                        </div>
                    </div>

                    </div>

                    <div className="row row--40">
            <div className="section-title">
                    
                    <Card style={{marginBottom:"20px", marginTop:"20px"}}>
                    <Card.Body className="cardBackground">
                        <Card.Title><b className="theme-gradient" style={{fontSize:"30px", padding: "20px"}}>UFTAA Current Updates</b></Card.Title>
                        <Card.Text>
                        <Slider className="rn-slick-dot rn-slick-arrow mb--5" {...settings}>
                            {TestimonialData.map((data, index) => (
                                <div key={index} className={`testimonial-style-two`}>
                                    <div className="row align-items-center row--20">
                                        <div className="order-2 order-md-1 col-lg-9 col-md-12 offset-lg-1">
                                            <div className="content mt_sm--20">
                                                <p style={{fontWeight:"bold", fontSize:"17px"}}>{data.name}</p>
                                                <p style={{fontSize:"15px"}}>{data.description}</p>
                                            </div>
                                        </div>
                                    
                                    </div> 
                                </div>
                            ))}
                        </Slider>                
                        </Card.Text>
                    </Card.Body>
                    </Card>

                    
            </div>
                 </div>

                    <div className="row row--30">
                    <div className="col-lg-12 mt--40">
                        <SectionTitle
                            textAlign = "text-center"
                            radiusRounded = ""
                            subtitle = "Leadership"
                            // title = "Contact us about anything related to our company or services."
                            description = ""
                        />
                    </div>
                    <Slider className="rn-slick-dot rn-slick-arrow mb--5" {...settings2}>
                        {teamData.map((data, index) => (
                             <div className="col-lg-2 col-md-12 col-sm-12 col-12 mt--30" key={index}>
                             <div className={`rn-team team-style-default`} style={{marginLeft:"20px", marginRight:"20px"}}>
                                 <ScrollAnimation 
                                 animateIn="fadeInUp"
                                 animateOut="fadeInOut"
                                 animateOnce={true}>
                                     <div className="inner">
                                         <figure className="thumbnail">
                                             <img src={`./images/team/${data.image}.jpg`} style={{borderRadius:"0"}} alt="Corporate React Template" />
                                         </figure>
                                         <figcaption className="content">
                                             <h2 className="title" style={{fontSize:"20px"}}>{data.name}</h2>
                                             <h6 className="subtitle theme-gradient">{data.designation}</h6>
                                           
                                         </figcaption>
                                     </div>
                                 </ScrollAnimation>
                             </div>
                         </div>
                        ))}
                         </Slider>  
                    </div>
                {/* </div> */}
            </div>   
        </div>
    )
}

export default AboutTwo;
